import * as ExploreAPIService from '../services/api/requests/Explore'

// gets mall transportations
export const doGetTransportationMalls = async ({
  onSuccess = () => {},
  onError = () => {},
}) => {
  await ExploreAPIService.getTransportationMalls()
    .then(onSuccess)
    .catch(onError)
}

// get mall routes
export const doGetMallRoutes = async ({
  accessToken,
  mallId,
  onSuccess = () => {},
  onError = () => {},
}) => {
  await ExploreAPIService.getMallRoutes(accessToken, mallId)
    .then(onSuccess)
    .catch(onError)
}

// get location routes
export const doGetLocationRoutes = async ({
  locationId,
  onSuccess = () => {},
  onError = () => {},
}) => {
  await ExploreAPIService.getLocationRoutes(locationId)
    .then(onSuccess)
    .catch(onError)
}
